import { FETCH, initialState } from '@/store/actions/badges';

export default (state = initialState, action) => {
    switch (action.type) {
        case FETCH: {
            if (action.status === status.SUCCESS && !!action.data) {
                const items = action.data;
                return {
                    data: items,
                    selected: {},
                    loading: false
                };
            }
            return { ...state, loading: action.status === status.REQUEST };
        }

        default: {
            return state;
        }
    }
};
